import { render, staticRenderFns } from "./BaseBtnHome.vue?vue&type=template&id=311a455c&scoped=true&"
import script from "./BaseBtnHome.vue?vue&type=script&lang=js&"
export * from "./BaseBtnHome.vue?vue&type=script&lang=js&"
import style0 from "./BaseBtnHome.vue?vue&type=style&index=0&id=311a455c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a455c",
  null
  
)

export default component.exports